import { createContext, useState, useEffect, useContext } from "react";
import { useSelector } from "react-redux";
import io from "socket.io-client";
import { BASE_URL } from "./constants";

const SocketContext = createContext();

export const useSocketContext = () => {
  return useContext(SocketContext);
};

export const SocketContextProvider = ({ children }) => {
  const [socketDetails, setSocketDetails] = useState(null);
  const [onlineUsers, setOnlineUsers] = useState([]);
  const { userInfo } = useSelector((state) => state.auth);

  useEffect(() => {
    if (!userInfo?.selectedOutletId) return;
    const socket = io(BASE_URL, {
      transports: ["websocket"],
    });
    console.log("inside admin socket useEffect:", socket.id);
    socket.on("connect", () => {
      console.log("✅ Connected to socket server:", socket.id);
      socket.emit("join_admins_room", userInfo?.selectedOutletId);
    });
    // Orders sent while disconnected are not delivered later, so record
    // drops to explain any online order that was not printed
    socket.on("disconnect", (reason) => {
      console.warn("Order socket disconnected:", reason);
    });
    socket.on("connect_error", (err) => {
      console.warn("Order socket connection failed:", err.message);
    });
    setSocketDetails(socket);

    // Close this outlet's socket when the outlet changes, the user logs
    // out, or the provider unmounts; otherwise it stays connected in the
    // previous outlet's admins room
    return () => {
      socket.disconnect();
    };
  }, [userInfo?.selectedOutletId]);

  return (
    <SocketContext.Provider value={{ socketDetails, onlineUsers }}>
      {children}
    </SocketContext.Provider>
  );
};
